var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{attrs:{"bg-color":"white","name":"landing"}},[_c('f7-navbar',[_c('f7-nav-title',{attrs:{"title":"Welcome"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }